import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import { modalTypes } from "constants/types";
import { useDispatch } from "react-redux";
import { updateAutosavePreference } from "slices/addIn/authentication/actions";
import { hideModal } from "slices/app/actions/modals";

import classes from "./AddInTurnOffAutosave.module.scss";

const AddInTurnOffAutosave = () => {
  const dispatch = useDispatch();

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.ADD_IN_TURN_OFF_AUTOSAVE));
  };

  const onConfirm = async () => {
    onDismiss();
    await dispatch(updateAutosavePreference(false));
  };

  return (
    <Modal
      centered
      className={clsx("fade-in", classes.modal)}
      data-testid="turn-off-autosave-modal"
      onDismiss={onDismiss}
      show
    >
      <Modal.Header>Turning off Auto save</Modal.Header>

      <Modal.Body className={classes.body}>
        <p>
          This will prevent your changes from syncing automatically between
          VisibleThread and MS Word.
        </p>
        <p>Are you sure?</p>
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          onClick={onDismiss}
          variant={NewButtonVariant.l2}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="submit-button"
          onClick={onConfirm}
          variant={NewButtonVariant.l1}
        >
          Turn Off Auto save
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AddInTurnOffAutosave;
